import type { INotificationProps } from '@app/dashboard/types/innerLayout/notifications';

import ConsumerNotifications from './components/ConsumerNotifications';
import MerchantNotifications from './components/MerchantNotifications';

import styles from './NotificationSettings.module.scss';

const NotificationSettings = ({
  merchantFlags,
  updatedFlags,
  setUpdatedFlags,
}: INotificationProps) => {
  return (
    <div className={styles['notification-settings']}>  
      <ConsumerNotifications
        updatedFlags={updatedFlags}
        merchantFlags={merchantFlags}
        setUpdatedFlags={setUpdatedFlags}
      />
      <span className={styles['notification-settings__divider']} />
      <MerchantNotifications
        updatedFlags={updatedFlags}
        merchantFlags={merchantFlags}
        setUpdatedFlags={setUpdatedFlags}
      />
    </div>
  );
};

export default NotificationSettings;
